import type {StateCreator} from 'zustand'

export type DiffFilterState = {
  filterText: string
  fileExtensions: Record<string, number>
  unselectedFileExtensions: Set<string>
  showDeletedFiles?: boolean
  showOnlyManifestFiles?: boolean
  showOnlyOwnedFiles?: boolean
  showVendoredFiles?: boolean
  showViewedFiles?: boolean
}

export type DiffFilterSlice = {
  diffFilter: {
    state: DiffFilterState
    filtersInteractedWith: boolean
  }
  diffFilterActions: {
    updateDiffFilter: (filterState: Partial<DiffFilterState>, userInteracted?: boolean) => void
  }
}

export const createDiffFilterSlice =
  (): StateCreator<DiffFilterSlice, [['zustand/devtools', never]], [], DiffFilterSlice> => (set, get) => ({
    diffFilter: {
      state: {
        filterText: '',
        fileExtensions: {},
        unselectedFileExtensions: new Set(),
        showDeletedFiles: true,
        showOnlyManifestFiles: false,
        showOnlyOwnedFiles: false,
        showVendoredFiles: true,
        showViewedFiles: true,
      },
      filtersInteractedWith: false,
    },
    diffFilterActions: {
      updateDiffFilter: (updatedDiffFilterState: Partial<DiffFilterState>, userInteracted?: boolean) => {
        set(
          {
            diffFilter: {
              state: {
                ...get().diffFilter.state,
                ...updatedDiffFilterState,
              },
              filtersInteractedWith: get().diffFilter.filtersInteractedWith || !!userInteracted,
            },
          },
          undefined,
          'updateFilters',
        )
      },
    },
  })
